// NOTE: due to timelines and complexity, this is ONLY used for High School and K8 Training
// For learning experiences, please refer to components/HsIndividualResourceMarkComplete

import MarkCompleteSectionContainer from './container'
export default MarkCompleteSectionContainer
